// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.set.from.js
// module id = 1376
// module chunks = 168707334958949